export default __webpack_public_path__ + "static/media/title_bar_image.15b03989.svg";